import { cn } from "@dalmatech/ui"

const root = cn("")
const container = ({
  isWelcomePage,
  isPricingPage,
  isBannerDisplayed,
  isRedirectIntoPrepackage,
  isAttributionQuestion,
  isPrepackage,
  isRecap,
  isHealthPage,
  isTribe,
  isMultiPetPrepackageBanner,
  isUserInfoPage,
}: {
  isWelcomePage: boolean
  isPricingPage: boolean
  isBannerDisplayed?: boolean
  isRedirectIntoPrepackage?: boolean
  isAttributionQuestion?: boolean
  isPrepackage?: boolean
  isRecap?: boolean
  isHealthPage?: boolean
  isTribe?: boolean
  isMultiPetPrepackageBanner?: boolean
  isUserInfoPage?: boolean
}) =>
  cn(
    "px-4 md:py-16 pt-[7rem] md:pt-[6.75rem] lg:pt-[7rem] md:pb-32 box-border",
    isRedirectIntoPrepackage ? "px-4 pb-0 md:pb-0" : "",
    isAttributionQuestion ? "pb-[8rem] md:py-16 md:pb-[6rem]" : "",
    isBannerDisplayed
      ? "md:pt-[13rem] pt-[10rem] lg:pt-[10rem]"
      : isMultiPetPrepackageBanner
      ? "pt-[142px] md:pt-[7.3rem] lg:pt-[148px]"
      : isPricingPage
      ? "pt-0 lg:pt-0 sm:pt-0 px-0 md:pb-16"
      : isWelcomePage
      ? "pt-2 md:pt-[2.5rem] lg:pt-[2.5rem] md:px-8"
      : "",
    isPrepackage ? "pb-[14rem] md:pb-[14rem]   " : "",
    isHealthPage ? "pb-[12rem] md:py-22" : "",
    isPricingPage ? "pb-[14rem] md:py-16 " : "",
    isRecap ? "pb-[12rem] md:py-22 md:pb-[6rem] " : "",
    isTribe ? "pb-[12rem]  md:py-16" : "",
    isUserInfoPage ? "pb-[12rem] md:pb-[1rem]" : ""
  )
const scroller = cn("relative")
export { container, root, scroller }
